// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__content .no-margin{
      margin-top:0;
    }
    .page__content > div{
      margin-top:1.25rem;
    }
    *.page__content > div[class^='col-']{
        padding-right:0;
        padding-left:0;
      }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
